import type { UIMatch } from 'react-router';

import type { TRouteHandle } from 'types/router';

import { DOCUMENT_TITLE } from '@/constants/system';

const resolveDocumentTitle = (matches: UIMatch[]): string => {
  let title: string = DOCUMENT_TITLE.base;

  matches.forEach((match) => {
    const handle = match.handle as TRouteHandle | null;

    if (handle?.title) {
      title = handle.title;
    }
  });

  return title;
};

export {
  resolveDocumentTitle,
};
